module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.call.successful) ? _c('span', {
    staticClass: "text-success"
  }, [_vm._m(0), _vm._v("\nAppel abouti : " + _vm._s(_vm.call.tags.map(function (tag) { return tag.name; }).join(', ')) + "\n")]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._m(1), _vm._v("\nAppel non abouti\n")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label label-pill label-success"
  }, [_c('i', {
    staticClass: "zmdi zmdi-phone",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label label-pill label-default"
  }, [_c('i', {
    staticClass: "zmdi zmdi-phone-missed",
    staticStyle: {
      "font-size": "1.2em"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502cc610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/Timeline/TimelineCallWidget.vue
// module id = 692
// module chunks = 1